// ** Third Party Components
import styled, { css } from "styled-components";
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledGridList = styled("ul")`
	margin: 0.5rem 0 1rem;
	display: grid;
	grid-template-columns: repeat(5, minmax(0, 1fr));
	grid-gap: var(--dz-sys-grid-gap);

	@media (max-width: ${breakpoints.desktop - 1}px) {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}
	@media (max-width: ${breakpoints.phone - 1}px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	${({ inHomePage, inRightColumn }) =>
		inHomePage && inRightColumn
			? css`
					grid-template-columns: repeat(2, minmax(0, 1fr));
					grid-row-gap: 0.5rem;
					grid-column-gap: 0.5rem;

					@media (max-width: ${breakpoints.giant - 1}px) {
						grid-template-columns: repeat(2, minmax(0, 1fr));
					}

					@media (max-width: ${breakpoints.desktop - 1}px) {
						grid-template-columns: repeat(3, minmax(0, 1fr));
					}

					@media (max-width: ${breakpoints.phone - 1}px) {
						grid-template-columns: repeat(2, minmax(0, 1fr));
					}
			  `
			: inHomePage &&
			  css`
					grid-template-columns: repeat(5, minmax(0, 1fr));
					grid-row-gap: 0.5rem;
					grid-column-gap: 0.5rem;

					@media (max-width: ${breakpoints.giant - 1}px) {
						grid-template-columns: repeat(3, minmax(0, 1fr));
					}

					@media (max-width: ${breakpoints.desktop - 1}px) {
						grid-template-columns: repeat(3, minmax(0, 1fr));
					}

					@media (max-width: ${breakpoints.phone - 1}px) {
						grid-template-columns: repeat(2, minmax(0, 1fr));
					}
			  `}

	${({ inProfile }) =>
		inProfile &&
		css`
			margin: 1rem 0 0;
		`}

	${({ inProfileContent }) =>
		inProfileContent &&
		css`
			margin: 0;
		`}

	${({ inNearby }) =>
		inNearby &&
		css`
			margin: 0;

			@media (max-width: ${breakpoints.phone - 1}px) {
				grid-template-columns: repeat(2, minmax(0, 1fr));
			}
		`}

	${({ inRankings }) =>
		inRankings &&
		css`
			margin-top: 0;
			margin-bottom: 0;
		`}


	li {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		@media (max-width: ${breakpoints.phone - 1}px) {
			padding: 0;
		}
	}
`;

StyledGridList.displayName = "BrowserGridList";

// #####################################################
